// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__10zLS","error":"Banner_error__3Tx84","icon":"Banner_icon__EUlua","info":"Banner_info__3YsH9","warning":"Banner_warning__3O7sb"};